<template>
	<span>
		<v-container fluid fill-height class="home-hero" style="max-height: 100vh;">
			<v-layout align-center justify-center fill-height>
				<!-- <v-flex
          class="display-3 font-weight-black black--text text-xs-center "  
         
        ><h1 >پازار سیستم
        </h1></v-flex> -->
				<!-- <v-flex
          class="display-2 font-weight-black black--text text-xs-left "  
         
        ><h3 >پازار پلاس / پازار 12
        </h3>
           <br>
        

         <v-btn color="black"  outline large href="/products">
       مشاهده محصولات
         </v-btn>
        </v-flex> -->
				<!-- <v-flex 
          class="display-3 font-weight-black black--text text-xs-center ">
          <h3 >سامانه نرم افزار پازار
        </h3>

              </v-flex> -->
			</v-layout>
		</v-container>

		<!-- <v-container fluid fill-height pa-0 style="max-height: 100vh;">
    <v-transition name="fade" >
    <v-img v-transition="fade" key="img1" :src="bgimage" height="100%" />
    </v-transition>
  </v-container> -->
	</span>
</template>

<script>
	export default {
		name: "HomeHero",
		data() {
			return {
				bgimage: require("@/assets/img/body/3.jpg"),
			};
		},
		// ,
		// components: {
		//     VueProgressiveImage: VueProgressiveImage
		// }
	};
</script>

<style scoped>
	.home-hero {
		/* background: url('http://source.unsplash.com/0BhSKStVtdM'); */
		/* background: url('~@/assets/img/water-ski-girl.png'); */
		background: url("~@/assets/img/body/3.jpg");
		background-size: cover;
		width: 100%;
		height: 100%;
	}
	.fade-enter,
	.fade-appear {
		opacity: 1;
	}
	.fade-enter-to,
	.fade.appear-to {
		opacity: 0;
	}
	.fade-enter-active,
	.fade-appear-active {
		transition: opacity 3s ease;
	}
</style>
